import React from "react";
import { Eye, EyeOff } from "lucide-react";
import { useEntitlements } from "../../lib/useEntitlements";

/**
 * AdminPreviewTierToggle — D7a (iter134).
 *
 * Renders a small pill fixed to the bottom-right ONLY for admin users.
 * Lets an admin flip their own account to "preview as Free" for 60m
 * so blurs + paywalls render on the admin account without needing
 * a throwaway user.
 *
 * Server enforces admin-only writes; non-admins can't hit
 * /admin/preview-tier/free.
 */
export default function AdminPreviewTierToggle() {
  const ent = useEntitlements();
  if (ent.loading || !ent.isAdmin) return null;
  const previewing = !!ent.previewAsFreeUntil &&
    new Date(ent.previewAsFreeUntil) > new Date();
  return (
    <div
      data-testid="admin-preview-tier-pill"
      className="fixed bottom-6 right-6 z-40 bg-[var(--bt-surface)] border border-[var(--bt-accent)] rounded-sm p-3 shadow-2xl flex items-center gap-3"
    >
      {previewing ? (
        <EyeOff className="w-4 h-4 text-[var(--bt-accent)]" />
      ) : (
        <Eye className="w-4 h-4 text-[var(--bt-text-muted)]" />
      )}
      <div className="text-xs font-mono uppercase leading-tight">
        <p className="text-[var(--bt-text-muted)]">Admin QA</p>
        <p className="text-[var(--bt-text)]">
          {previewing ? "Previewing as Free" : "Viewing as Elite"}
        </p>
      </div>
      <button
        data-testid="admin-preview-tier-toggle"
        onClick={async () => {
          await ent.togglePreviewAsFree(!previewing, 60);
          window.location.reload();
        }}
        className="px-2 py-1 text-[10px] font-mono uppercase rounded-sm border border-[var(--bt-accent)] text-[var(--bt-accent)] hover:bg-[var(--bt-accent)] hover:text-black transition-colors"
      >
        {previewing ? "Exit preview" : "Preview as Free"}
      </button>
    </div>
  );
}
